import React, { useState } from 'react';
import './CaseCard.css';

const CaseCard = ({ title, image, description, link }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <a href={link} className={`case-card ${flipped ? 'flipped' : ''}`}>
      <div className="case-card__inner">
        <div className="case-card__front">
          <div className="case-card__image">
            <img src={image} alt={title} />
          </div>
          <div className="case-card__title">{title}</div>
        </div>

        <div className="case-card__back">
          <div className="case-card__description">{description}</div>
        </div>
      </div>
    </a>
  );
};

export default CaseCard;
